//GLOBAL - components from npm
import React from "react";

//STYLES
import "./image-profile.css";

//COMPONENTS
//import { Typography } from "../../general";
import Typography from "../Typography";
//import { Tippy } from "../../feedback";

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
import ProfileUser from "../../build/images/image-profile-comp/HistoricUser.svg";

export default function ImageProfile({
  profile = {
    nome_usuario: "User name",
    nome_organizacao: "Company name",
  },
  iconHistory,
  iconChange,
  className,
  iconClassName,
  changeName,
  theName,
  tooltip = true,
  client = false,
}) {
  // Icons functions
  let pathIcons = "";

  //GENERAL
  // switch (iconHistory) {

  //   case "user":
  //     pathIcons = ProfileUser;
  //     break;

  //   default:
  //     iconHistory = false;
  //     break;
  // }

  //STATES

  //REDUX - Selectors

  //FUNCTIONS
  var name = undefined;
  if (profile.nome_usuario) {
    name = profile.nome_usuario.split(".").toString();
  }
  var resultName = undefined;

  if (name) {
    resultName = name.replace(",", " ");
  }

  function renderProfileName(fullname) {
    var start = undefined;
    var name = undefined;
    var surname = undefined;
    if (fullname) {
      fullname = fullname.replace(/\s(de|da|dos|das)\s/g, " ");
      start = fullname.match(/\b(\w)/gi);
      name = fullname.slice(0, 1).toUpperCase();
    }

    if (start) {
      surname = start
        .splice(1, start.length - 1)
        .join("")
        .toUpperCase();
    }

    return name + surname;
  }

  function renderImageProfile() {
    if (tooltip)
      return (
        <>
          {profile.image ? (
            <img
              alt="imagem de perfil"
              src={profile.image}
              className={`image-profile__img ${className}`}
            />
          ) : (
            <div className={`image-profile ${className}`}>
              {iconHistory === "user" ? (
                <img
                  src={ProfileUser}
                  alt="Icone do historico"
                  className={`icon-history-color ${iconClassName}`}
                />
              ) : (
                <Typography.H5 weight="bold" color="white">
                  {renderProfileName(resultName)}
                </Typography.H5>
              )}
            </div>
          )}
        </>
      );
    else
      return (
        <>
          {profile.image ? (
            <img
              alt="imagem de perfil"
              src={profile.image}
              className={`image-profile__img ${className}`}
            />
          ) : (
            <div className={`image-profile ${className}`}>
              {iconHistory === "user" ? (
                <img
                  src={ProfileUser}
                  alt="Icone do historico"
                  className={`icon-history-color ${iconClassName}`}
                />
              ) : (
                <Typography.H4 weight="bold" color="white">
                  {profile.nome_usuario
                    ? profile.nome_usuario.slice(0, 1)
                    : null}
                </Typography.H4>
              )}
            </div>
          )}
        </>
      );
  }

  //USE EFFECTS

  return renderImageProfile();
}
